import LoginIcon from '@mui/icons-material/Login';
import Button from '@mui/material/Button';
import { useMatchRoute } from '@tanstack/react-router';
import { useCallback, useState } from 'react';

import { Toast } from '#components/toast/toast.js';
import { useAuth0Context } from '#state/contexts/auth0-context.js';
import { useAddToast } from '#state/stores/toast-store.js';
import { buildLoginRedirectOptions, collectLoginCampaignTags } from '#utils/auth0-campaign.js';

import type { Auth0AppState } from '#utils/auth0-app-state.js';

export function UserControlLoggedOut() {
	const auth0 = useAuth0Context();
	const addToast = useAddToast();
	const matchRoute = useMatchRoute();

	const [isLoading, setIsLoading] = useState(false);

	const handleLogIn = useCallback(() => {
		setIsLoading(true);

		void auth0.client
			.loginWithRedirect<Auth0AppState>(
				buildLoginRedirectOptions({
					// If we're on the `logged-out` page, redirect back to the root. Otherwise, redirect back to the current page.
					returnTo:
						matchRoute({ to: '/logged-out' }) !== false ? '/' : (
							window.location.pathname + window.location.search + window.location.hash
						),
					tags: collectLoginCampaignTags(),
				}),
			)
			.catch((error: unknown) => {
				setIsLoading(false);
				addToast(
					<Toast severity='error' title='Login failed'>
						{error instanceof Error ? error.message : 'Failed to log in.'}
					</Toast>,
				);
			});
	}, [addToast, auth0.client, matchRoute]);

	return (
		<Button startIcon={<LoginIcon />} loading={isLoading} onClick={handleLogIn}>
			<span>Log in</span>
		</Button>
	);
}
